module.exports = "/assets/data/a8f0d73d6dc20add18e0b4e7458599b7-DA3.data.json";